/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_FilesInputs */

const en_label_files = /** @type {(inputs: Label_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files`)
};

const id_label_files = /** @type {(inputs: Label_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

/** @type {(inputs: Label_FilesInputs) => LocalizedString} */
const es_label_files = en_label_files;

/** @type {(inputs: Label_FilesInputs) => LocalizedString} */
const fr_label_files = en_label_files;

/** @type {(inputs: Label_FilesInputs) => LocalizedString} */
const de_label_files = en_label_files;

/** @type {(inputs: Label_FilesInputs) => LocalizedString} */
const ja_label_files = en_label_files;

/** @type {(inputs: Label_FilesInputs) => LocalizedString} */
const zh_label_files = en_label_files;

/** @type {(inputs: Label_FilesInputs) => LocalizedString} */
const ar_label_files = en_label_files;

/** @type {(inputs: Label_FilesInputs) => LocalizedString} */
const it_label_files = en_label_files;

/** @type {(inputs: Label_FilesInputs) => LocalizedString} */
const ru_label_files = en_label_files;

/** @type {(inputs: Label_FilesInputs) => LocalizedString} */
const pt_label_files = en_label_files;

/** @type {(inputs: Label_FilesInputs) => LocalizedString} */
const ko_label_files = en_label_files;

/**
* | output |
* | --- |
* | "Files" |
*
* @param {Label_FilesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_files = /** @type {((inputs?: Label_FilesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_FilesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_files(inputs)
	if (locale === "es") return es_label_files(inputs)
	if (locale === "fr") return fr_label_files(inputs)
	if (locale === "de") return de_label_files(inputs)
	if (locale === "ja") return ja_label_files(inputs)
	if (locale === "zh") return zh_label_files(inputs)
	if (locale === "ar") return ar_label_files(inputs)
	if (locale === "id") return id_label_files(inputs)
	if (locale === "it") return it_label_files(inputs)
	if (locale === "ru") return ru_label_files(inputs)
	if (locale === "pt") return pt_label_files(inputs)
	return ko_label_files(inputs)
});